import httpClient from "../apiRequests/httpClient";
import { clearSessionToken } from "./sessionToken";

const clearClientSession = () => {
  document.cookie =
    "token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=Strict";
  localStorage.removeItem("headerData");
  clearSessionToken();
};

const signUserOut = async () => {
  try {
    const response = await httpClient.delete("/SignOut");
    if (response.status === 204 || response.status === 200) {
      clearClientSession();
    }
    return response;
  } catch (error) {
    // Still drop local session if the server rejects a dead/blacklisted token.
    console.error("Error:", error);
    clearClientSession();
    throw error;
  }
};

export default signUserOut;
